(function () {
  'use strict';

  var SELECTOR = {
    root: '[data-club-pdp]',
    purchase: '[data-club-purchase]',
    modeInput: '[data-club-mode-input]',
    order: '[data-club-order]',
    popup: '[data-club-popup]',
    popupClose: '[data-club-popup-close]',
    thumb: '[data-club-thumb]',
    mainImage: '[data-club-main-image]',
    stuckBtn: '[data-club-order][aria-busy="true"]',
  };

  var READY_FLAG = 'clubPdpReady';

  var isSubmitting = false;

  function reportError(message, err) {
    console.error(message, err);
    if (window.Sentry) window.Sentry.captureException(err);
  }

  function attr(el, name) {
    return (el.getAttribute(name) || '').trim();
  }

  // "Today" in Europe/London, at UTC noon. The club page has no date model any
  // more; this survives only for the one-order-a-day gate below.
  function londonToday() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    }).formatToParts(new Date());
    var get = function (type) {
      return Number(
        parts.find(function (p) {
          return p.type === type;
        }).value
      );
    };
    return new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12, 0, 0));
  }

  // "2026-09-12" for today in London — compared against the customer's
  // custom.club_last_order_date, which Flow writes in the same format. The
  // Europe/London anchor has to stay: a UTC or local-time "today" would open
  // or close the gate an hour early around the BST switch.
  function todayKey() {
    return londonToday().toISOString().slice(0, 10);
  }

  function clubConfig() {
    return (window.PXUTheme && window.PXUTheme.club) || {};
  }

  function cartService() {
    var svc = window.CartService;
    if (!svc) return null;
    if (typeof svc.prepareCheckout !== 'function') return null;
    if (typeof svc.getCart !== 'function') return null;
    return svc;
  }

  // --- Purchase mode --------------------------------------------------------
  function purchaseBlock(root) {
    return root.querySelector(SELECTOR.purchase);
  }

  function currentMode(root) {
    var checked = root.querySelector(SELECTOR.modeInput + ':checked');
    return checked ? checked.value : 'club';
  }

  function applyMode(root) {
    var block = purchaseBlock(root);
    if (!block) return;
    var club = currentMode(root) === 'club';
    block.classList.toggle('is-mode-club', club);
    block.classList.toggle('is-mode-onetime', !club);
    document.body.classList.toggle('po-subscribe-selected', club);
  }

  // --- Gallery --------------------------------------------------------------
  function initGallery(root) {
    var main = root.querySelector(SELECTOR.mainImage);
    if (!main) return;

    root.addEventListener('click', function (e) {
      var thumb = e.target.closest(SELECTOR.thumb);
      if (!thumb || !root.contains(thumb)) return;

      var src = thumb.getAttribute('data-club-src');
      if (!src) return;
      main.src = src;
      main.srcset = thumb.getAttribute('data-club-srcset') || '';

      root.querySelectorAll(SELECTOR.thumb).forEach(function (el) {
        el.classList.toggle('is-active', el === thumb);
      });
    });
  }

  // --- Popups ---------------------------------------------------------------
  // Popups are <dialog>s (snippets/club-lp-popup): showModal puts them in the
  // top layer; the [open] attribute is the fallback for browsers without it.
  function openPopup(root, name) {
    var popup = root.querySelector('[data-club-popup="' + name + '"]');
    if (!popup) return;
    closePopups(root);
    if (typeof popup.showModal === 'function') {
      popup.showModal();
    } else {
      popup.setAttribute('open', '');
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function closePopups(root) {
    var wasOpen = false;
    root.querySelectorAll(SELECTOR.popup).forEach(function (popup) {
      if (!popup.hasAttribute('open')) return;
      wasOpen = true;
      if (typeof popup.close === 'function') {
        popup.close();
      } else {
        popup.removeAttribute('open');
      }
    });
    if (wasOpen) document.documentElement.style.overflow = '';
  }

  // --- Club rules -----------------------------------------------------------
  function hasOrderedToday(root) {
    if (attr(root, 'data-club-daily-limit') !== 'true') return false;
    var last = String(clubConfig().lastOrderDate || '').trim();
    return last !== '' && last === todayKey();
  }

  // --- Cart -----------------------------------------------------------------
  function setBusy(btn) {
    btn.setAttribute('aria-busy', 'true');
  }

  function setIdle(btn) {
    btn.removeAttribute('aria-busy');
  }

  function membershipPlan(state) {
    var cfg = clubConfig();
    if (state === 'returning' || state === 'expired') {
      return Number(cfg.planRenew) || Number(cfg.planTrial) || 0;
    }
    return Number(cfg.planTrial) || 0;
  }

  function clubPayload(root) {
    var cfg = clubConfig();
    var variantId = attr(root, 'data-club-variant');
    if (!variantId) return null;

    var source = attr(root, 'data-club-order-source');
    var bouquet = { variantId: variantId, quantity: 1, properties: {} };
    if (source) bouquet.properties._order_source = source;
    if (attr(root, 'data-club-bouquet') === 'true') bouquet.properties._club_landing = 'true';

    var items = [bouquet];
    var state = attr(root, 'data-club-state');
    if (state !== 'member' && cfg.variantId) {
      var membership = { variantId: cfg.variantId, quantity: 1 };
      var plan = membershipPlan(state);
      if (plan > 0) membership.sellingPlan = plan;
      items.push(membership);
    }

    return {
      request: {
        // delivery_date is deliberately sent EMPTY, not omitted: the theme no
        // longer knows the date (checkout owns it now), and /cart/clear.js does
        // not clear cart attributes — a date left behind by an ordinary product
        // page would otherwise ride into this order and reach the OMS. Same
        // reasoning as the empty club_offer.
        items: items,
        attributes: {
          delivery_date: '',
          order_source: source,
          club_offer: '',
          club_order: '',
        },
        clear: 'auto',
        // Клубный заказ — ровно букет (+ членство): чужих строк в чекауте быть
        // не должно, сбор аппу тут не положен (cart-service.js settleCheckout).
        exclusive: true,
      },
      // MFS-5621: optional greeting-card step between this page and checkout.
      // Club variant only — the One time route is decided by
      // onetimeDestination() below and is deliberately left alone, because a
      // one-off £45 purchase carries no membership and no club card offer.
      // Empty setting = straight to checkout (kill switch, same as the landing).
      destination: attr(root, 'data-club-card-step-url') || '/checkout',
    };
  }

  function onetimeDestination(root) {
    var flow = attr(root, 'data-club-onetime-flow');
    if (flow === 'cart') return '/cart';
    if (flow === 'addons') return attr(root, 'data-club-addons-url') || '/cart';
    return '/checkout';
  }

  function onetimePayload(root) {
    var variantId = attr(root, 'data-club-onetime-variant');
    if (!variantId || variantId === '0') return null;

    return {
      request: {
        items: [{ variantId: variantId, quantity: 1 }],
        // MFS-5827 п.9: club_offer не трогаем — подписка в корзине остаётся включённой.
        attributes: { delivery_date: '', order_source: '', club_order: '' },
        // Брошенный клубный заказ (назад из чекаута, bfcache: Club £9.90 +
        // членство) снимается тем же запросом, что и сброс атрибутов, — иначе он
        // уезжал на all-gifts, где гигиена сносила корзину целиком вместе с этой
        // покупкой (QA MFS-5933 п. 10.1). Обычная подписка в корзине остаётся:
        // план не трогает членство при club_offer: subscribe.
        clear: clubFlowPlan(),
      },
      destination: onetimeDestination(root),
    };
  }

  // План от слоя правил (assets/club-cart.js); без него — обычное добавление.
  function clubFlowPlan() {
    var club = window.MFClub;
    if (club && typeof club.clubFlowPlan === 'function') return club.clubFlowPlan;
    console.warn('Club PDP: MFClub.clubFlowPlan is missing, abandoned club lines are not removed');
    return false;
  }

  function submit(root) {
    if (isSubmitting) return;

    var cart = cartService();
    var btn = root.querySelector(SELECTOR.order);
    if (!cart || !btn) return;

    var payload = currentMode(root) === 'club' ? clubPayload(root) : onetimePayload(root);
    if (!payload) return;

    isSubmitting = true;
    setBusy(btn);

    cart
      .prepareCheckout(payload.request)
      .then(function () {
        window.location.href = payload.destination;
      })
      .catch(function (err) {
        isSubmitting = false;
        setIdle(btn);
        reportError('Club PDP: add to cart failed', err);
      });
  }

  function initRoot(root) {
    if (root.dataset[READY_FLAG] === 'true') return;
    root.dataset[READY_FLAG] = 'true';

    applyMode(root);

    initGallery(root);

    root.addEventListener('change', function (e) {
      if (!e.target.closest(SELECTOR.modeInput)) return;
      applyMode(root);
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest(SELECTOR.popupClose)) {
        closePopups(root);
        return;
      }

      var btn = e.target.closest(SELECTOR.order);
      if (!btn) return;
      e.preventDefault();

      if (currentMode(root) !== 'club') {
        submit(root);
        return;
      }
      if (hasOrderedToday(root)) {
        openPopup(root, 'oops');
        return;
      }
      submit(root);
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(SELECTOR.root).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll(SELECTOR.root).forEach(closePopups);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll(SELECTOR.root).forEach(closePopups);
  });

  // Back/forward cache: the page comes back with the CTA still spinning from
  // the order that navigated away from it.
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    isSubmitting = false;
    document.querySelectorAll(SELECTOR.stuckBtn).forEach(setIdle);
  });
})();
